import * as _ from "lodash-es";
import React, { Component } from "react";
import Modal from "react-modal";
import { Link, NavigateFunction } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import ICatalogDeduplicateDTO from "../../../models/DTO/ICatalogDeduplicateDTO";
import IDeleteCatalogDTO from "../../../models/DTO/IDeleteCatalogDTO";
import IDuplicateCatalogDTO from "../../../models/DTO/IDuplicateCatalogDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IErrorItemUpdateDTO from "../../../models/DTO/IErrorItemUpdateDTO";
import IGetCatalogCSVCategoryTemplate from "../../../models/DTO/IGetCatalogCSVCategoryTemplate";
import IGetCatalogCSVInventoryDTO from "../../../models/DTO/IGetCatalogCSVInventoryDTO";
import IGetCatalogCSVItemTemplateDTO from "../../../models/DTO/IGetCatalogCSVItemTemplateDTO";
import { IGetCatalogCSVPriceGroupsDTO } from "../../../models/DTO/IGetCatalogCSVPriceGroupsDTO";
import IGetCatalogCSVPriceUpdateDTO from "../../../models/DTO/IGetCatalogCSVPriceUpdateDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IGetMaterialsTemplateDTO from "../../../models/DTO/IGetMaterialsTemplateDTO";
import IOnCatalogDeduplicateDTO from "../../../models/DTO/IOnCatalogDeduplicateDTO";
import IOnCreateFileUploadDTO from "../../../models/DTO/IOnCreateFileUploadDTO";
import IOnDeleteCatalogDTO from "../../../models/DTO/IOnDeleteCatalogDTO";
import IOnDeleteFileUploadDTO from "../../../models/DTO/IOnDeleteFileUploadDTO";
import IOnDuplicateCatalogDTO from "../../../models/DTO/IOnDuplicateCatalogDTO";
import IOnGetCatalogCSVCategoryTemplateDTO from "../../../models/DTO/IOnGetCatalogCSVCategoryTemplateDTO";
import IOnGetCatalogCSVInventoryDTO from "../../../models/DTO/IOnGetCatalogCSVInventoryDTO";
import IOnGetCatalogCSVItemTemplateDTO from "../../../models/DTO/IOnGetCatalogCSVItemTemplateDTO";
import { IOnGetCatalogCSVPriceGroupsDTO } from "../../../models/DTO/IOnGetCatalogCSVPriceGroupsDTO";
import IOnGetCatalogCSVPriceUpdateDTO from "../../../models/DTO/IOnGetCatalogCSVPriceUpdateDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetMaterialsTemplateDTO from "../../../models/DTO/IOnGetMaterialsTemplateDTO";
import IOnPerformCatalogCSVItemTemplateUpdateDTO from "../../../models/DTO/IOnPerformCatalogCSVItemTemplateUpdateDTO";
import IOnReconcilePriceGroupsDTO from "../../../models/DTO/IOnReconcilePriceGroupsDTO";
import IOnShopifyPushInventoryDTO from "../../../models/DTO/IOnShopifyPushInventoryDTO";
import IOnShopifySyncProductsDTO from "../../../models/DTO/IOnShopifySyncProductsDTO";
import IOnWooCommercePullCatalogItemsDTO from "../../../models/DTO/IOnWooCommercePullCatalogItemsDTO";
import IOnWooCommercePushCatalogItemsDTO from "../../../models/DTO/IOnWooCommercePushCatalogItemsDTO";
import IOpenCartConnectExistingCatalogItemsDTO from "../../../models/DTO/IOpenCartConnectExistingCatalogItemsDTO";
import IOpenCartOnConnectExistingCatalogItemsDTO from "../../../models/DTO/IOpenCartOnConnectExistingCatalogItemsDTO";
import IOpenCartOnPushCatalogItemsDTO from "../../../models/DTO/IOpenCartOnPushCatalogItemsDTO";
import IOpenCartPushCatalogItemsDTO from "../../../models/DTO/IOpenCartPushCatalogItemsDTO";
import IProcessedItemsDetailsDTO from "../../../models/DTO/IProcessedItemDetailsDTO";
import IQBOConnectCatalogItemsDTO from "../../../models/DTO/IQBOConnectCatalogItemsDTO";
import IQBOOnConnectCatalogItemsDTO from "../../../models/DTO/IQBOOnConnectCatalogItemsDTO";
import IQBOOnPullAndDownloadCatalogItemsDTO from "../../../models/DTO/IQBOOnPullAndDownloadCatalogItemsDTO";
import IQBOOnPushCatalogItemsDTO from "../../../models/DTO/IQBOOnPushCatalogItemsDTO";
import IQBOOnSyncCatalogItemsDTO from "../../../models/DTO/IQBOOnSyncCatalogItemsDTO";
import IQBOPullAndDownloadCatalogItemsDTO from "../../../models/DTO/IQBOPullAndDownloadCatalogItemsDTO";
import IQBOPushCatalogItemsDTO from "../../../models/DTO/IQBOPushCatalogItemsDTO";
import IQBOSyncCatalogItemsDTO from "../../../models/DTO/IQBOSyncCatalogItemsDTO";
import IQBOSyncCatalogItemsEndDTO from "../../../models/DTO/IQBOSyncCatalogItemsEndDTO";
import IQBOSyncCatalogItemsStartDTO from "../../../models/DTO/IQBOSyncCatalogItemsStartDTO";
import IQBOSyncCatalogItemsUpdateDTO from "../../../models/DTO/IQBOSyncCatalogItemsUpdateDTO";
import IReconcilePriceGroupsDTO from "../../../models/DTO/IReconcilePriceGroupsDTO";
import IShopifyPushInventoryDTO from "../../../models/DTO/IShopifyPushInventoryDTO";
import IShopifySyncProductsDTO from "../../../models/DTO/IShopifySyncProductsDTO";
import IWooCommercePullCatalogItemsDTO from "../../../models/DTO/IWooCommercePullCatalogItemsDTO";
import IWooCommercePushCatalogItemsDTO from "../../../models/DTO/IWooCommercePushCatalogItemsDTO";
import IXeroGetCatalogItemsDTO from "../../../models/DTO/IXeroGetCatalogItemsDTO";
import IXeroOnGetCatalogItemsDTO from "../../../models/DTO/IXeroOnGetCatalogItemsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IAction from "../../../models/IAction";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICatalog from "../../../models/ICatalog";
import ICatalogUI from "../../../models/ICatalogUI";
import INotification from "../../../models/INotification";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import UserService from "../../../services/UserService";
import OwActionBar from "../../shared/OwActionBar/OwActionBar";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwProcessedItemsDetails from "../../shared/OwProcessedItemsDetails/OwProcessedItemsDetails";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import CatalogDetailView from "./CatalogDetailView/CatalogDetailView";
import "./Catalogs.scss";
import { CatalogReconcileVendorLocations } from "./CatalogReconcileVendorLocations/CatalogReconcileVendorLocations";
import CatalogSidebar from "./CatalogSidebar/CatalogSidebar";
import CatalogUploadUpdateModal from "./CatalogUploadUpdateModal/CatalogUploadUpdateModal";
import FishbowlPullCatalogItems from "./FishbowlPullCatalogItems/FishbowlPullCatalogItems";
import IOnGetCatalogImagesCsvDTO from "../../../models/DTO/IOnGetCatalogImagesCsvDTO";
import ICatalogGetImagesCsvDTO from "../../../models/DTO/ICatalogGetImagesCsvDTO";
import IWayfairOnConnectCatalogItemsDTO from "../../../models/DTO/IWayfairOnConnectCatalogItemsDTO";
import IWayfairConnectCatalogItemsDTO from "../../../models/DTO/IWayfairConnectCatalogItemsDTO";
import { WayfairInventoryUpdateModal } from "./WayfairInventoryUpdateModal/WayfairInventoryUpdateModal";
import UIService from "../../../services/UIService";
import InventoryService from "../../../services/InventoryService";
import { QboPushCatalogItemsModal } from "./QboPushCatalogItemsModal/QboPushCatalogItemsModal";
import { ShopifySyncCatalogItemsModal } from "./ShopifySyncCatalogItemsModal/ShopifySyncCatalogItemsModal";
import IShopifySyncProductsProgressDTO from "../../../models/DTO/IShopifySyncProductsProgressDTO";
import IZoeyOnPullCatalogItemsDTO from "../../../models/DTO/IZoeyOnPullCatalogItemsDTO";
import IZoeyPullCatalogItemsDTO from "../../../models/DTO/IZoeyPullCatalogItemsDTO";
import { ShopifyPushInventoryModal } from "./ShopifyPushInventoryModal/ShopifyPushInventoryModal";
import IBigCommerceOnPullProductsDTO from "../../../models/DTO/IBigCommerceOnPullProductsDTO";
import IBigCommercePullProductsDTO from "../../../models/DTO/IBigCommercePullProductsDTO";
import IOnBigCommercePushInventoryLevelsDTO from "../../../models/DTO/IOnBigCommercePushInventoryLevelsDTO";
import IBigCommercePushInventoryLevelsDTO from "../../../models/DTO/IBigCommercePushInventoryLevelsDTO";
import { QBOPullCatalogItemsModal } from "./QBOPullCatalogItemsModal/QBOPullCatalogItemsModal";
import { QBOPullCategoriesModal } from "./QBOPullCategoriesModal/QBOPullCategoriesModal";
import { ItemTemplateDownloadModal, ItemTemplateDownloadFilters } from "./ItemTemplateDownloadModal/ItemTemplateDownloadModal";
import IQBOOnPullCategoriesDTO from "@models/DTO/IQBOOnPullCategoriesDTO";
import { BigCommercePullProductsModal } from "./BigCommercePullProductsModal/BigCommercePullProductsModal";
import { Socket } from "socket.io-client";
import IOnGetCatalogCSVItemCategoriesDTO from "../../../models/DTO/IOnGetCatalogCSVItemCategoriesDTO";
import IGetCatalogCSVItemCategoriesDTO from "../../../models/DTO/IGetCatalogCSVItemCategoriesDTO";
import IGetCatalogCSVKitBuilderTemplateDTO from "../../../models/DTO/IGetCatalogCSVKitBuilderTemplateDTO";
import IQBOReconcileCatalogAndQboItemsDTO from "../../../models/DTO/IQBOReconcileCatalogAndQboItemsDTO";
import IQBOOnReconcileCatalogAndQboItemsDTO from "../../../models/DTO/IQBOOnReconcileCatalogAndQboItemsDTO";
import IRecalculateReservedQtyOnHandDTO from "../../../models/DTO/IRecalculateReservedQtyOnHandDTO";
import IOnRecalculateReservedQtyOnHandDTO from "../../../models/DTO/IOnRecalculateReservedQtyOnHandDTO";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import IQuickBooksOnlineOnInventoryReconciliationDTO from "../../../models/DTO/IQuickBooksOnlineOnInventoryReconciliationDTO";
import moment from "moment";
import IQuickBooksOnlineInventoryReconciliationDTO from "../../../models/DTO/IQuickBooksOnlineInventoryReconciliationDTO";
import { ConnectQboCatalogItemsModal } from "./ConnectQboCatalogItemsModal/ConnectQboCatalogItemsModal";
import IGetCatalogCSVPriceBandsDTO from "../../../models/DTO/IGetCatalogCSVPriceBandsDTO";
import IOnGetCatalogCSVPriceBandsDTO from "../../../models/DTO/IOnGetCatalogCSVPriceBandsDTO";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { IOnGetCatalogCSVAttributesDTO } from "@models/DTO/IOnGetCatalogCSVAttributesDTO";
import { IGetCatalogCSVAttributesDTO } from "@models/DTO/IGetCatalogCSVAttributesDTO";
import IOnGetCatalogCSVKitBuilderTemplateDTO from "@models/DTO/IOnGetCatalogCSVKitBuilderTemplateDTO";
import IGetPriceBandsBulkApplyCsvTemplateDTO from "@models/DTO/IGetPriceBandsBulkApplyCsvTemplateDTO";
import IOnGetPriceBandsBulkApplyCsvTemplateDTO from "@models/DTO/IOnGetPriceBandsBulkApplyCsvTemplateDTO";
import RestEndpointsEnum from "@models/RestEndpointsEnum";
import { buildRestUrl, buildAuthHeadersForFetch } from "@services/RestService";
import IOnGetItemOptionAssignmentTemplateDTO from "@models/DTO/IOnGetItemOptionAssignmentTemplateDTO";
import { ClickToCopy } from "@components/shared/ClickToCopy/ClickToCopy";
import { IInventoryResetDTO, IOnInventoryResetDTO } from "@models/DTO/IInventoryResetDTO";
import { InventoryResetModal } from "./InventoryResetModal/InventoryResetModal";
import { NYSLAExportModal } from "./NYSLAExportModal/NYSLAExportModal";
import { NYSLASetupAttributesModal } from "./NYSLASetupAttributesModal/NYSLASetupAttributesModal";
import { IUiContextModel } from "@contexts/UiContext";
import WineService from "../../../services/WineService";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    setSidebarComponent: (component: any) => void;
    showHiddenFeatures: boolean;
    isReadOnly: boolean;
    uiContext: IUiContextModel;
    navigate: NavigateFunction;
};

type State = {
    navItems: IBreadcrumbs[];
    catalogs: ICatalogUI[];
    activeSyncCatalogItems: boolean;
    supplierIntegrations?: any;
    activePullQboItems: boolean;
    activePushQboItems: boolean;
    activeConnectQboItems: boolean;
    activePullQboCategories: boolean;
    activeDownloadQboCategories: boolean;
    actions: IAction[];
    tableCols: IOwTableCols[];
    isFetchingData: boolean;
    isInitialData: boolean;
    checkedRows: { [key: string]: boolean };
    currentQboPullStart: number;
    currentQboPullTotal: number;
    qboPushErroredRows: number;
    qboPushErroredRowsDetail: any;
    showPullQboDismiss: boolean;
    showPushQboDismiss: boolean;
    modalComponent: any;
    modalIsOpen: boolean;
    modalStyle: {
        content: {
            top: string;
            left: string;
            right: string;
            bottom: string;
            color: string;
            backgroundColor: string;
            border: string;
        };
        overlay: {
            zIndex: number;
        };
    };
    isWooCommerceInventoryBtnActive: boolean;
    isWooCommercePullCatalogItemsBtnActive: boolean;
    isWooCommercePushCatalogItemsBtnActive: boolean;
    isFishbowlActive: boolean;
    isShopifySyncActive: boolean;
    showShopifySyncDetails: boolean;
    shopifySyncDetails: {
        totalRecords: number;
        recordsUpdated: number;
        recordsCreated: number;
        recordsNotUpdated: number;
        recordsErrored: number;
        errorItems: IErrorItemUpdateDTO[];
    };
    isOpenCartActive: boolean;
    selectedCatalog?: ICatalog;
    selectedRowElem?: any;
    showSyncStatus: boolean;
    processedItemsDetails: IProcessedItemsDetailsDTO | null;
    actionActive: boolean;
    xeroGetItemsActive: boolean;
    isWayfairActive: boolean;
    isZoeyActive: boolean;
    activeShopifySync: boolean;
    currentShopifyProcessed: number;
    currentShopifyTotalProducts: number;
    downloadCsvActive: boolean;
    downloadCsvAction:
        | "price_list"
        | "inventory"
        | "price_groups"
        | "categories"
        | "item_template"
        | "images"
        | "item_categories"
        | "price_bands"
        | "price_bands_bulk_apply"
        | "attributes"
        | "kit_builder_template"
        | "item_options_bulk_assign"
        | "wine_excel_export"
        | "nysla_export"
        | "";
    bigCommerceActive: boolean;
    duplicateActive: boolean;
    selectedRowElemId: string | null;
};

class Catalogs extends Component<Props, State> {
    refEl: any = null;

    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        document.title = `Orderwerks >> Catalogs`;

        const actions: IAction[] = [];

        this.state = {
            navItems: [
                { title: "Dashboard", url: "/dashboard" },
                { title: "Catalogs", url: "/catalogs" },
            ],
            catalogs: [],
            activeSyncCatalogItems: false,
            activePullQboItems: false,
            activePushQboItems: false,
            activeConnectQboItems: false,
            activePullQboCategories: false,
            activeDownloadQboCategories: false,
            actions,
            tableCols: [
                {
                    title: "",
                    isActionsCol: true,
                    renderFn: this.actionsCol,
                    valueProp: "",
                    // hasChevron: true,
                    showChevronFn: () => {
                        return true;
                    },
                },
                {
                    title: "name",
                    valueProp: "name",
                    renderFn: this.renderCatalogName,
                    renderFnEmitsRow: true,
                },
                {
                    title: "version",
                    valueProp: "version",
                },
                {
                    title: "active",
                    valueProp: "active",
                    className: "text-center",
                    renderFn: this.getActiveIcon,
                },
                {
                    title: "currency",
                    valueProp: "Currency",
                    className: "text-center",
                    renderFn: this.renderCurrency,
                    renderFnEmitsRow: true,
                    notVisible: !this.props.supplierModel.has_currencies,
                },
                {
                    title: "pdf",
                    valueProp: "active",
                    className: "text-center",
                    renderFn: this.getHasPDF,
                    renderFnEmitsRow: true,
                },
                {
                    title: "inventory_last_updated",
                    valueProp: "last_inventory_update",
                    renderFn: this.parseLastInventoryUpdated,
                },
                {
                    title: "last_updated",
                    valueProp: "updated_at",
                    renderFn: this.parseLastUpdated,
                },
                {
                    title: "",
                    valueProp: "",
                    renderFn: this.actionBtnsCol,
                    renderFnEmitsRow: true,
                },
            ],
            isFetchingData: false,
            isInitialData: true,
            checkedRows: {},
            currentQboPullStart: 0,
            currentQboPullTotal: 0,
            showPullQboDismiss: false,
            showPushQboDismiss: false,
            qboPushErroredRows: 0,
            qboPushErroredRowsDetail: [],
            modalIsOpen: false,
            modalComponent: null,
            modalStyle: {
                content: {
                    top: "10px",
                    left: "10px",
                    right: "10px",
                    bottom: "10px",
                    color: "var(--main-text-color)",
                    backgroundColor: "var(--main-bg-color)",
                    border: "1px solid var(--minor-bg-color)",
                },
                overlay: {
                    zIndex: 100,
                },
            },
            isWooCommercePullCatalogItemsBtnActive: false,
            isWooCommerceInventoryBtnActive: false,
            isWooCommercePushCatalogItemsBtnActive: false,
            isFishbowlActive: false,
            isShopifySyncActive: false,
            showShopifySyncDetails: false,
            shopifySyncDetails: {
                totalRecords: 0,
                recordsUpdated: 0,
                recordsCreated: 0,
                recordsNotUpdated: 0,
                recordsErrored: 0,
                errorItems: [],
            },
            isOpenCartActive: false,
            showSyncStatus: false,
            processedItemsDetails: null,
            actionActive: false,
            downloadCsvActive: false,
            downloadCsvAction: "",
            xeroGetItemsActive: false,
            isWayfairActive: false,
            isZoeyActive: false,
            activeShopifySync: false,
            currentShopifyProcessed: 0,
            currentShopifyTotalProducts: 0,
            bigCommerceActive: false,
            duplicateActive: false,
            selectedRowElemId: null,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: this.onGetCatalogs },
            { endpoint: EndpointsEnum.CatalogsOnCreateCatalog, fn: this.onCreateCatalog },
            { endpoint: EndpointsEnum.CatalogsOnDeleteCatalog, fn: this.onDeleteCatalog },
            { endpoint: EndpointsEnum.QBOOnSyncInventory, fn: this.onSyncInventory },
            { endpoint: EndpointsEnum.QBOSyncCatalogItemsStart, fn: this.qboSyncCatalogItemsStart },
            { endpoint: EndpointsEnum.QBOSyncCatalogItemsUpdate, fn: this.qboSyncCatalogItemsUpdate },
            { endpoint: EndpointsEnum.QBOSyncCatalogItemsEnd, fn: this.qboSyncCatalogItemsEnd },
            { endpoint: EndpointsEnum.QBOOnSyncCatalogItems, fn: this.qboOnSyncCatalogItems },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVInventory, fn: this.onGetCatalogCSVInventory },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVPriceUpdate, fn: this.onGetCatalogCSVPriceGroup },
            { endpoint: EndpointsEnum.CatalogsOnPerformCatalogCSVInventoryUpdate, fn: this.onGetCatalogCSVItemInventoryUpdate },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVItemTemplate, fn: this.onGetCatalogCSVItemTemplate },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVKitBuilderTemplate, fn: this.onGetCatalogCSVKitBuilderTemplate },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVPriceBands, fn: this.onGetCatalogCSVPriceBands },
            { endpoint: EndpointsEnum.WooCommerceOnPullCatalogItems, fn: this.onWooCommercePullCatalogItems },
            { endpoint: EndpointsEnum.WooCommerceOnPushCatalogItems, fn: this.onWooCommercePushCatalogItems },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVCategoryTemplate, fn: this.onGetCatalogCSVCategories },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVPriceGroups, fn: this.onGetCatalogCSVPriceGroups },
            { endpoint: EndpointsEnum.ShopifyOnSyncProducts, fn: this.onShopifySyncProducts },
            { endpoint: EndpointsEnum.ShopifyOnPushInventory, fn: this.onShopifyPushInventory },
            { endpoint: EndpointsEnum.QBOOnPushCatalogItems, fn: this.onPushQboCatalogItems },
            { endpoint: EndpointsEnum.QBOOnConnectCatalogItems, fn: this.onConnectQboCatalogItems },
            { endpoint: EndpointsEnum.FileUploadOnCreateFileUpload, fn: this.onCreateFileUpload },
            { endpoint: EndpointsEnum.FileUploadOnDeleteFileUpload, fn: this.onDeleteFileUpload },
            { endpoint: EndpointsEnum.CatalogsOnDuplicateCatalog, fn: this.onDuplicateCatalog },
            { endpoint: EndpointsEnum.OpenCartOnConnectExistingCatalogItems, fn: this.onOpenCartConnectCatalogItems },
            { endpoint: EndpointsEnum.OpenCartOnPushCatalogItems, fn: this.onOpenCartPushCatalogItems },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.QBOOnPullAndDownloadCatalogItems, fn: this.qboOnPullAndDownloadCatalogItems },
            { endpoint: EndpointsEnum.CatalogOnReconcilePriceGroups, fn: this.onReconcilePriceGroups },
            { endpoint: EndpointsEnum.XeroOnGetItems, fn: this.onXeroGetItems },
            { endpoint: EndpointsEnum.CatalogOnDeduplicate, fn: this.onReconcilePriceGroups },
            { endpoint: EndpointsEnum.CatalogOnGetImagesCSV, fn: this.onGetImagesCSV },
            { endpoint: EndpointsEnum.WayfairOnConnectCatalogItems, fn: this.onWayfairConnectCatalogItems },
            { endpoint: EndpointsEnum.ShopifySyncProductsProgress, fn: this.shopifySyncProductsProgress },
            { endpoint: EndpointsEnum.ZoeyOnPullCatalogItems, fn: this.onZoeyPullItems },
            { endpoint: EndpointsEnum.BigCommerceOnPullProducts, fn: this.onBigCommercePullProducts },
            { endpoint: EndpointsEnum.BigCommerceOnPushInventoryLevels, fn: this.onBigCommercePushInventory },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVItemCategories, fn: this.onGetCatalogCSVItemCategories },
            { endpoint: EndpointsEnum.QBOOnReconcileCatalog, fn: this.onQboDownloadReconcileFile },
            { endpoint: EndpointsEnum.CatalogsOnRecalculateReservedQtyOnHand, fn: this.onRecalculateReservedQtyOnHand },
            { endpoint: EndpointsEnum.QBOOnDownloadReconciliationExcel, fn: this.onQboDownloadReconcilationExcel },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogCSVAttributes, fn: this.onGetCatalogCSVAttributes },
            { endpoint: EndpointsEnum.CatalogsOnGetPriceBandsBulkApplyCsvTemplate, fn: this.onGetPriceBandsBulkApplyCsvTemplate },
        ];
    }

    async componentDidMount() {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        const downloadCsvGroupActions: IAction[] = [
            {
                fn: this.getCatalogCSVPriceUpdate,
                name: "price_list",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "price_list";
                },
            },
            {
                fn: this.getCatalogCSVInventory,
                name: "inventory",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "inventory";
                },
            },
            {
                fn: this.getCatalogCSVPriceGroup,
                name: "price_groups",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "price_groups";
                },
            },
            {
                fn: this.getCatalogCSVPriceBands,
                name: "price_bands",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "price_bands";
                },
                btnClass: () => {
                    return this.props.supplierModel.has_price_bands ? "" : "d-none";
                },
            },
            {
                fn: this.getCatalogCSVPriceBandsBulkApply,
                name: "price_bands_bulk_apply",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "price_bands_bulk_apply";
                },
                btnClass: () => {
                    return this.props.supplierModel.has_price_bands ? "" : "d-none";
                },
            },
            {
                fn: this.getCatalogCSVKitBuilderTemplate,
                name: "kit_builder",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "kit_builder_template";
                },
            },
            {
                fn: this.getCatalogCSVCategories,
                name: "categories",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "categories";
                },
            },
            {
                fn: this.getCatalogCSVAttributes,
                name: "attributes",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "attributes";
                },
            },
            {
                fn: this.getCatalogItemTemplate,
                name: "item_template",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "item_template";
                },
            },
        ];

        if (this.props.supplierModel.allow_multiple_categories) {
            downloadCsvGroupActions.push({
                fn: this.getCatalogItemCategories,
                name: "item_categories",
                leftIconClass: "fad fa-download",
                disabledFn: this.hasOnlyOneChecked,
                isActive: () => {
                    return this.state.downloadCsvActive && this.state.downloadCsvAction === "item_categories";
                },
            });
        }

        downloadCsvGroupActions.push({
            fn: this.getImagesCSV,
            name: "images",
            leftIconClass: "fad fa-download",
            disabledFn: this.hasOnlyOneChecked,
            isActive: () => {
                return this.state.downloadCsvActive && this.state.downloadCsvAction === "images";
            },
        });

        downloadCsvGroupActions.push({
            fn: this.getItemOptionsBulkAssignCSV,
            name: "item_options_bulk_assign",
            leftIconClass: "fad fa-download",
            disabledFn: this.hasOnlyOneChecked,
            isActive: () => {
                return this.state.downloadCsvActive && this.state.downloadCsvAction === "item_options_bulk_assign";
            },
        });

        // if (this.props.supplierModel.has_bom) {
        //     downloadCsvGroupActions.push({
        //         fn: this.getMaterialsTemplate,
        //         name: "materials",
        //         leftIconClass: "fad fa-download",
        //         disabledFn: this.hasOnlyOneChecked
        //     })
        // }

        let actions: IAction[] = [
            {
                name: "actions",
                fn: () => {},
                isDropdownGroup: true,
                groupActions: [
                    {
                        name: "duplicate",
                        disabledFn: this.hasOnlyOneChecked,
                        fn: this.duplicateCatalog,
                        leftIconClass: "fad fa-copy",
                        isActive: () => {
                            return this.state.duplicateActive;
                        },
                    },
                    {
                        name: "reconcile_price_groups",
                        disabledFn: this.hasOnlyOneChecked,
                        fn: this.reconcilePriceGroups,
                        leftIconClass: "fad fa-pencil",
                        // btnClass: () => {
                        //     return this.props.showHiddenFeatures ? "" : "d-none";
                        // },
                        isActive: () => {
                            return this.state.actionActive;
                        },
                    },
                    {
                        name: "recalculate_reserved_qty_on_hand",
                        disabledFn: this.hasOnlyOneChecked,
                        fn: this.recalculateReservedQtyOnHand,
                        leftIconClass: "fad fa-retry",
                        btnClass: () => {
                            return this.props.showHiddenFeatures ? "" : "d-none";
                        },
                        isActive: () => {
                            return this.state.actionActive;
                        },
                    },
                    {
                        name: "reset_inventory",
                        disabledFn: this.hasOnlyOneChecked,
                        fn: this.showResetInventoryModal,
                        leftIconClass: "fad fa-eraser",
                        btnClass: () => {
                            return this.props.showHiddenFeatures ? "" : "d-none";
                        },
                        isActive: () => {
                            return this.state.actionActive;
                        },
                    },
                    {
                        name: "audit_inventory",
                        disabledFn: this.hasOnlyOneChecked,
                        fn: this.auditInventory,
                        leftIconClass: "fad fa-check-circle",
                        btnClass: () => {
                            return this.props.showHiddenFeatures ? "" : "d-none";
                        },
                        isActive: () => {
                            return this.state.actionActive;
                        },
                    },
                    {
                        name: "audit_inventory_and_fix",
                        disabledFn: this.hasOnlyOneChecked,
                        fn: this.auditAndFixInventory,
                        leftIconClass: "fad fa-check-circle",
                        btnClass: () => {
                            return this.props.showHiddenFeatures ? "" : "d-none";
                        },
                        isActive: () => {
                            return this.state.actionActive;
                        },
                    },
                    {
                        name: "deduplicate",
                        disabledFn: this.hasOnlyOneChecked,
                        fn: this.deduplicate,
                        leftIconClass: "fad fa-pencil",
                        btnClass: () => {
                            return this.props.showHiddenFeatures ? "" : "d-none";
                        },
                        isActive: () => {
                            return this.state.actionActive;
                        },
                    },
                    {
                        name: "reconcile_vendor_source_locations",
                        fn: this.showReconcileVendorLocationsModal,
                        leftIconClass: "fad fa-pencil",
                        btnClass: () => {
                            return this.props.showHiddenFeatures ? "" : "d-none";
                        },
                        isActive: () => {
                            return this.state.actionActive;
                        },
                    },
                ],
            },
            {
                name: "download_csv",
                isDropdownGroup: true,
                fn: () => {},
                groupActions: downloadCsvGroupActions,
            },
        ];

        const alcoholIndustryActions: IAction = {
            name: "alcohol_industry",
            leftIconClass: "fad fa-wine-bottle",
            isDropdownGroup: true,
            fn: () => {},
            groupActions: [],
        };

        const hasNYSLA =
            WineService.isNYSLAEligibleSupplier(this.props.supplierModel) && this.props.supplierModel.Supplier_Integration.has_nysla;

        if (WineService.isWineIndustrySupplier(this.props.supplierModel)) {
            if (Array.isArray(alcoholIndustryActions.groupActions)) {
                alcoholIndustryActions.groupActions.push({
                    fn: this.getWineExcelExport,
                    name: "by_price_group_price_export",
                    disabledFn: this.hasOnlyOneChecked,
                    isActive: () => {
                        return this.state.downloadCsvActive && this.state.downloadCsvAction === "wine_excel_export";
                    },
                    hasDividerAfter: hasNYSLA,
                });
            }
        }

        // Add NYSLA options if eligible and enabled
        if (hasNYSLA) {
            if (Array.isArray(alcoholIndustryActions.groupActions)) {
                alcoholIndustryActions.groupActions.push({
                    fn: this.showNYSLAExportModal,
                    name: "nysla_price_posting_export",
                    disabledFn: this.hasOnlyOneChecked,
                    isActive: () => {
                        return this.state.downloadCsvActive && this.state.downloadCsvAction === "nysla_export";
                    },
                });

                alcoholIndustryActions.groupActions.push({
                    fn: this.showNYSLASetupAttributesModal,
                    name: "nysla_setup_attributes",
                    disabledFn: this.hasOnlyOneChecked,
                });
            }
        }

        if (WineService.isWineIndustrySupplier(this.props.supplierModel) || hasNYSLA) {
            actions.push(alcoholIndustryActions);
        }

        if (this.props.supplierModel.Supplier_Integration.has_xero) {
            actions = [
                ...actions,
                {
                    name: "xero",
                    isDropdownGroup: true,
                    fn: () => {},
                    disabledFn: this.hasOnlyOneChecked,
                    groupActions: [
                        {
                            name: "pull_items",
                            fn: this.xeroGetItems,
                            disabledFn: this.hasOnlyOneChecked,
                            isActive: this.isXeroActive,
                        },
                    ],
                },
            ];
        }

        if (this.props.supplierModel.Supplier_Integration.has_zoey) {
            actions = [
                ...actions,
                {
                    name: "zoey",
                    isDropdownGroup: true,
                    fn: () => {},
                    disabledFn: this.hasOnlyOneChecked,
                    groupActions: [
                        {
                            name: "pull_items",
                            fn: this.zoeyPullItems,
                            disabledFn: this.hasOnlyOneChecked,
                            isActive: () => {
                                return this.state.isZoeyActive;
                            },
                        },
                    ],
                },
            ];
        }

        if (this.props.supplierModel.Supplier_Integration.has_bigcommerce) {
            actions = [
                ...actions,
                {
                    name: "bigcommerce",
                    isDropdownGroup: true,
                    fn: () => {},
                    groupActions: [
                        {
                            name: "pull_products",
                            fn: this.showBigCommercePullProductsModal,
                            isActive: () => {
                                return this.state.bigCommerceActive;
                            },
                        },
                        {
                            name: "push_inventory",
                            fn: this.bigCommercePushInventory,
                            isActive: () => {
                                return this.state.bigCommerceActive;
                            },
                        },
                    ],
                },
            ];
        }

        if (this.props.supplierModel.Supplier_Integration.has_unanet) {
            actions = [
                ...actions,
                {
                    name: "unanet",
                    isDropdownGroup: true,
                    fn: () => {},
                    groupActions: [
                        {
                            name: "edit_gl_account_mappings",
                            fn: this.goToUnanetGlAccountMappings,
                        },
                    ],
                },
            ];
        }

        if (this.props.supplierModel.Supplier_Integration.has_qbo) {
            actions = [
                ...actions,
                {
                    name: "quickbooks_online",
                    isDropdownGroup: true,
                    fn: () => {},
                    disabledFn: this.hasOnlyOneChecked,
                    groupActions: [
                        {
                            name: "pull_inventory",
                            fn: this.qboSyncInventory,
                            disabledFn: this.hasOnlyOneChecked,
                            isActive: this.isQboSyncActive,
                        },
                        {
                            name: "pull_catalog_items",
                            fn: this.showQboPullCatalogItemsModel,
                            disabledFn: this.hasOnlyOneChecked,
                            isActive: this.isQboSyncActive,
                        },
                        {
                            name: "pull_categories",
                            fn: this.showQboPullCategoriesModal,
                            disabledFn: this.hasOnlyOneChecked,
                            isActive: () => this.state.activePullQboCategories,
                        },
                        {
                            name: "push_catalog_items",
                            fn: this.showQboPushCatalogItemsModal,
                            disabledFn: this.hasOnlyOneChecked,
                            isActive: () => {
                                return this.state.activePushQboItems;
                            },
                        },
                        {
                            name: "connect_catalog_items",
                            fn: this.showConnectQboCatalogItemsModal,
                            disabledFn: this.hasOnlyOneChecked,
                            isActive: () => {
                                return this.state.activeConnectQboItems;
                            },
                        },
                        {
                            name: "download_data",
                            isActive: () => {
                                return this.state.activePushQboItems;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.qboPullAndDownloadProductsFn,
                            leftIconClass: "fad fa-download",
                            btnClass: () => {
                                return this.props.showHiddenFeatures ? "" : "d-none";
                            },
                        },
                        {
                            name: "download_reconcile_excel",
                            isActive: () => {
                                return this.state.activePushQboItems;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.qboDownloadReconcileFile,
                            leftIconClass: "fad fa-download",
                            btnClass: () => {
                                return this.props.showHiddenFeatures ? "" : "d-none";
                            },
                        },
                        {
                            name: "inventory_reconcile_excel",
                            isActive: () => {
                                return this.state.activePushQboItems;
                            },
                            disabledFn: this.hasOnlyOneChecked,
                            fn: this.qboDownloadReconciliationInventoryExcel,
                            leftIconClass: "fad fa-download",
                        },
                        {
                            name: "download_categories",
                            isActive: () => {
                                return this.state.activeDownloadQboCategories;
                            },
                            disabledFn: () => {
                                return false;
                            },
                            fn: this.qboDownloadCategories,
                            leftIconClass: "fad fa-download",
                            btnClass: () => {
                                return this.props.showHiddenFeatures ? "" : "d-none";
                            },
                        },
                    ],
                },
            ];
        }

        if (this.props.supplierModel.Supplier_Integration.has_fishbowl) {
            actions = [
                ...actions,
                {
                    name: "fishbowl",
                    isDropdownGroup: true,
                    fn: () => {},
                    disabledFn: this.hasOnlyOneChecked,
                    groupActions: [
                        {
                            name: "pull_catalog_items",
                            fn: this.fishbowlPullItems,
                            disabledFn: this.hasOnlyOneChecked,
                            isActive: () => {
                                return this.state.isFishbowlActive;
                            },
                        },
                    ],
                },
            ];
        }

        if (this.props.supplierModel.Supplier_Integration.has_woocommerce) {
            actions = [
                ...actions,
                {
                    name: "woocommerce",
                    isDropdownGroup: true,
                    fn: () => {},
                    disabledFn: this.isNotWooCommerceCatalog,
                    groupActions: [
                        {
                            name: "push_catalog_items",
                            fn: this.wooCommercePushCatalogItems,
                            disabledFn: this.isNotWooCommerceCatalog,
                            isActive: this.state.isWooCommercePushCatalogItemsBtnActive,
                        },
                        {
                            name: "pull_catalog_items",
                            fn: this.wooCommercePullCatalogItems,
                            disabledFn: this.isNotWooCommerceCatalog,
                            isActive: this.state.isWooCommercePullCatalogItemsBtnActive,
                        },
                    ],
                },
            ];
        }

        if (this.props.supplierModel.Supplier_Integration.has_shopify) {
            actions = [
                ...actions,
                {
                    name: "shopify",
                    isDropdownGroup: true,
                    fn: () => {},
                    disabledFn: this.isNotShopifyCatalog,
                    groupActions: [
                        {
                            name: "sync_catalog_items",
                            fn: this.shopifyShowSyncModal,
                            // disabledFn: this.isNotShopifyCatalog,
                            isActive: () => {
                                return this.state.isShopifySyncActive;
                            },
                        },
                        {
                            name: "push_inventory",
                            fn: this.shopifyShowInventoryModal,
                            isActive: () => {
                                return this.state.isShopifySyncActive;
                            },
                        },
                    ],
                },
            ];
        }

        if (this.props.supplierModel.Supplier_Integration.has_wayfair) {
            actions = [
                ...actions,
                {
                    name: "wayfair",
                    isDropdownGroup: true,
                    fn: () => {},
                    disabledFn: this.isNotWayfairCatalog,
                    groupActions: [
                        {
                            name: "connect_items",
                            fn: this.wayfairConnectCatalogItems,
                            disabledFn: this.isNotWayfairCatalog,
                            isActive: () => {
                                return this.state.isWayfairActive;
                            },
                        },
                        {
                            name: "push_inventory",
                            fn: this.showWayfairInventoryUpdateModal,
                            disabledFn: this.isNotWayfairCatalog,
                            isActive: () => {
                                return this.state.isWayfairActive;
                            },
                        },
                    ],
                },
            ];
        }

        if (this.props.supplierModel.Supplier_Integration.has_opencart) {
            actions = [
                ...actions,
                {
                    name: "opencart",
                    isDropdownGroup: true,
                    fn: () => {},
                    disabledFn: this.isNotOpenCartCatalog,
                    groupActions: [
                        {
                            name: "push_catalog_items",
                            fn: this.openCartPushCatalogItems,
                            disabledFn: this.isNotOpenCartCatalog,
                            isActive: () => {
                                return this.state.isOpenCartActive;
                            },
                        },
                        {
                            name: "connect_catalog_items",
                            fn: this.openCartConnectCatalogItems,
                            disabledFn: this.isNotOpenCartCatalog,
                            isActive: () => {
                                return this.state.isOpenCartActive;
                            },
                        },
                    ],
                },
            ];
        }

        this.setState(
            {
                actions,
            },
            () => {
                this.getCatalogs();
            }
        );
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (!this.props.showHiddenFeatures) {
            // console.log('window', window);

            // @ts-expect-error
            if (!_.isNil(window.showHiddenFeatures)) {
                this.setState({
                    showHiddenFeatures: true,
                });
            }
        }
    }

    goToUnanetGlAccountMappings = () => {
        const selectedCatalogGuid = this.getCheckedCatalogGuid();

        const url = `/catalogs/${selectedCatalogGuid}/unanet/gl-account-mapping`;

        this.props.navigate(url);
    };

    bigCommercePushInventory = () => {
        const payload: IBigCommercePushInventoryLevelsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.BigCommercePushInventoryLevels, payload);

        this.setState({
            bigCommerceActive: true,
        });
    };

    onBigCommercePushInventory = (data: IOnBigCommercePushInventoryLevelsDTO) => {
        const processedItemsDetails: IProcessedItemsDetailsDTO = {
            totalProcessed: data.totalProcessed,
            totalCreated: 0,
            errorDetails: [],
            totalErrored: 0,
            totalUpdated: data.totalUpdated,
        };

        const message: INotification = {
            message: "successfully_pushed_bigcommerce_inventory",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, message);

        this.setState({
            bigCommerceActive: false,
            processedItemsDetails,
        });
    };

    showBigCommercePullProductsModal = () => {
        const modalComponent = (
            <BigCommercePullProductsModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                startFn={this.bigCommercePullProducts}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    bigCommercePullProducts = (payload: IBigCommercePullProductsDTO) => {
        this.props.socket.emit(EndpointsEnum.BigCommercePullProducts, payload);

        this.setState({
            bigCommerceActive: true,
            modalComponent: null,
            modalIsOpen: false,
        });
    };

    onBigCommercePullProducts = (data: IBigCommerceOnPullProductsDTO) => {
        const processedItemsDetails: IProcessedItemsDetailsDTO = {
            totalProcessed: data.totalPulled,
            totalCreated: data.totalCreated,
            errorDetails: data.errorDetails.map((item) => {
                return { error: item.details, item: item.sku };
            }),
            totalErrored: data.totalErrors,
            totalUpdated: data.totalUpdated,
        };

        this.setState({
            bigCommerceActive: false,
            processedItemsDetails,
        });
    };

    zoeyPullItems = () => {
        const payload: IZoeyPullCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ZoeyPullCatalogItems, payload);

        this.setState({
            isZoeyActive: true,
        });
    };

    onZoeyPullItems = (data: IZoeyOnPullCatalogItemsDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_catalog_items",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            isZoeyActive: false,
        });
    };

    isNotWayfairCatalog = (): boolean => {
        const disableCheckedActions = this.hasOnlyOneChecked();

        const selectedCatalogId = this.getCheckedCatalogId();

        if (disableCheckedActions) {
            return true;
        }

        return this.props.supplierModel.Supplier_Integration.wayfair_catalog_id !== selectedCatalogId;
    };

    wayfairConnectCatalogItems = () => {
        const selectedCatalogGuid = this.getCheckedCatalogGuid();

        const payload: IWayfairConnectCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: selectedCatalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.WayfairConnectCatalogItems, payload);
    };

    onWayfairConnectCatalogItems = (data: IWayfairOnConnectCatalogItemsDTO) => {
        console.log(data);
    };

    showWayfairInventoryUpdateModal = () => {
        const modalComponent = (
            <WayfairInventoryUpdateModal closeModalFn={this.closeModal} socket={this.props.socket} notifyFn={this.props.notifyFn} />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    xeroGetItems = () => {
        const selectedCatalogGuid = this.getCheckedCatalogGuid();

        const payload: IXeroGetCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: selectedCatalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.XeroGetItems, payload);

        this.setState({
            xeroGetItemsActive: true,
        });
    };

    onXeroGetItems = (data: IXeroOnGetCatalogItemsDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_items",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            xeroGetItemsActive: false,
        });
    };

    renderCatalogName = (row: ICatalog) => {
        return (
            <div>
                <div>
                    <Link className={"view"} to={`/catalogs/${row.guid}`}>
                        {row.name}
                    </Link>
                </div>
                {this.props.supplierModel.Supplier_Integration.has_fishbowl &&
                this.props.supplierModel.Supplier_Integration.fishbowl_auto_refresh_inventory ? (
                    <div className={"text-small text-muted"}>
                        {row.fishbowl_auto_refresh_inventory ? (
                            <div>
                                <OwLabel title={"auto_refresh_inventory"} />
                            </div>
                        ) : null}
                    </div>
                ) : null}
                {this.props.showHiddenFeatures ? (
                    <div className="d-flex flex-column">
                        <div className="d-flex align-items-center">
                            ID: <ClickToCopy text={row.id.toString()} className="ms-2" />
                        </div>
                        <div className="d-flex align-items-center">
                            GUID: <ClickToCopy text={row.guid} className="ms-2" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    };

    notify = () => {
        this.setState({
            isOpenCartActive: false,
            isFishbowlActive: false,
            isShopifySyncActive: false,
            isWooCommerceInventoryBtnActive: false,
            isWooCommercePushCatalogItemsBtnActive: false,
            isFetchingData: false,
            isInitialData: false,
            isZoeyActive: false,
            bigCommerceActive: false,
        });
    };

    isNotOpenCartCatalog = () => {
        const disableCheckedActions = this.hasOnlyOneChecked();

        const selectedCatalogGuid = this.getCheckedCatalogGuid();

        const isDisabled = true;

        if (disableCheckedActions) {
            return isDisabled;
        }

        return false;
    };

    openCartPushCatalogItems = () => {
        const selectedCatalogGuid = this.getCheckedCatalogGuid();

        const payload: IOpenCartPushCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: selectedCatalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.OpenCartPushCatalogItems, payload);

        this.setState({
            isOpenCartActive: true,
        });
    };

    onOpenCartPushCatalogItems = (data: IOpenCartOnPushCatalogItemsDTO) => {
        const notification: INotification = {
            message: `successfully_pushed_catalog_items`,
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            isOpenCartActive: false,
        });
    };

    openCartConnectCatalogItems = () => {
        const selectedCatalogGuid = this.getCheckedCatalogGuid();

        const payload: IOpenCartConnectExistingCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: selectedCatalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.OpenCartConnectExistingCatalogItems, payload);

        this.setState({
            isOpenCartActive: true,
        });
    };

    onOpenCartConnectCatalogItems = (data: IOpenCartOnConnectExistingCatalogItemsDTO) => {
        const notification: INotification = {
            message: `successfully_connected_catalog_items`,
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            isOpenCartActive: false,
        });
    };

    isNotShopifyCatalog = () => {
        const disableCheckedActions = this.hasOnlyOneChecked();

        const selectedCatalogGuid = this.getCheckedCatalogGuid();

        let isDisabled = true;

        if (this.props.supplierModel.Supplier_Integration.shopify_options?.default_catalog_id) {
            const catalogModel = this.state.catalogs.find((catalog) => {
                return catalog.id === Number(this.props.supplierModel.Supplier_Integration.shopify_options?.default_catalog_id);
            });

            if (catalogModel) {
                isDisabled = !(catalogModel.guid === selectedCatalogGuid);
            }
        }

        return isDisabled;

        // if (this.props.supplierModel.Supplier_Integration.woocommerce_options?.default_catalog_id) {
        //     const catalogModel = this.state.catalogs.find((catalog) => {
        //         return catalog.id === Number(this.props.supplierModel.Supplier_Integration.woocommerce_options?.default_catalog_id);
        //     });
        //
        //     console.log("catalogModel", catalogModel);
        //
        //     if (catalogModel) {
        //         isDisabled = !(catalogModel.guid === selectedCatalogGuid);
        //         console.log("isDisabled: ", isDisabled);
        //
        //         return isDisabled;
        //     } else {
        //         return isDisabled;
        //     }
        // } else {
        //     return isDisabled;
        // }
    };

    shopifyShowInventoryModal = () => {
        const modalComponent = (
            <ShopifyPushInventoryModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                startProcessing={this.shopifyPushInventory}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    shopifyShowSyncModal = () => {
        const modalComponent = (
            <ShopifySyncCatalogItemsModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                startProcessing={this.shopifySyncProducts}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    shopifySyncProducts = (options: Partial<IShopifySyncProductsDTO>) => {
        if (options.shopGuid) {
            const payload: IShopifySyncProductsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                includePhotos: options.includePhotos || false,
                shopGuid: options.shopGuid,
            };

            this.props.socket.emit(EndpointsEnum.ShopifySyncProducts, payload);

            this.setState({
                isShopifySyncActive: true,
                modalIsOpen: false,
                modalComponent: null,
                activeShopifySync: true,
            });
        }
    };

    onShopifySyncProducts = (data: IOnShopifySyncProductsDTO) => {
        this.setState({
            isShopifySyncActive: false,
            showShopifySyncDetails: true,
            shopifySyncDetails: data,
            activeShopifySync: false,
        });
    };

    shopifySyncProductsProgress = (data: IShopifySyncProductsProgressDTO) => {
        this.setState({
            activeShopifySync: true,
            currentShopifyProcessed: data.totalProcessed,
            currentShopifyTotalProducts: data.totalProducts,
        });
    };

    shopifyPushInventory = (options: Partial<IShopifyPushInventoryDTO>) => {
        if (options) {
            const payload: IShopifyPushInventoryDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                shopGuid: options.shopGuid,
            };

            this.props.socket.emit(EndpointsEnum.ShopifyPushInventory, payload);

            this.setState({
                isShopifySyncActive: true,
                modalIsOpen: false,
                modalComponent: null,
                activeShopifySync: true,
            });
        }
    };

    onShopifyPushInventory = (data: IOnShopifyPushInventoryDTO) => {
        this.setState({
            isShopifySyncActive: false,
            showShopifySyncDetails: true,
            shopifySyncDetails: data,
        });
    };

    dismissShopifySyncDetails = () => {
        this.setState({
            showShopifySyncDetails: false,
        });
    };

    onCreateFileUpload = (data: IOnCreateFileUploadDTO) => {
        this.getCatalogs();
    };

    onDeleteFileUpload = (data: IOnDeleteFileUploadDTO) => {
        this.getCatalogs();
    };

    wooCommerceSyncInventory = () => {};

    onWooCommercePullCatalogItems = (data: IOnWooCommercePullCatalogItemsDTO) => {
        // display details to the user.
        const notification: INotification = {
            message: "successfully_pulled_catalog_items",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            isWooCommercePullCatalogItemsBtnActive: false,
        });
    };

    wooCommercePullCatalogItems = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IWooCommercePullCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.WooCommercePullCatalogItems, payload);

        this.setState({
            isWooCommercePullCatalogItemsBtnActive: true,
        });
    };

    onWooCommercePushCatalogItems = (data: IOnWooCommercePushCatalogItemsDTO) => {
        this.setState({
            isWooCommercePushCatalogItemsBtnActive: false,
        });
    };

    wooCommercePushCatalogItems = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IWooCommercePushCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.WooCommercePushCatalogItems, payload);

        this.setState({
            isWooCommercePushCatalogItemsBtnActive: true,
        });
    };

    fishbowlPullItems = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const modal = <FishbowlPullCatalogItems catalogGuid={catalogGuid} closeModalFn={this.closeModal} />;

        this.setState({
            modalComponent: modal,
            modalIsOpen: true,
        });
    };

    actionBtnsCol = (row: ICatalog) => {
        if (this.props.isReadOnly) {
            return null;
        }

        return (
            <div className={"d-flex"}>
                <div>
                    <OwButton
                        className={"btn-danger upload"}
                        leftIconClass={"fas fa-upload"}
                        title={"upload"}
                        fn={() => {
                            this.showModal(row);
                        }}
                    />
                </div>
            </div>
        );
    };

    showModal = (catalogModel: ICatalog) => {
        const modalComponent = (
            <CatalogUploadUpdateModal
                closeModalFn={this.hideModal}
                socket={this.props.socket}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                catalogModel={catalogModel}
                notifyFn={this.props.notifyFn}
            />
        );

        this.setState({
            modalIsOpen: true,
            modalComponent,
        });
    };

    hideModal = () => {
        this.setState({
            modalIsOpen: false,
            modalComponent: null,
        });
    };

    duplicateCatalog = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const catalogModel = this.state.catalogs.find((catalog) => {
            return catalog.guid === catalogGuid;
        });

        if (catalogModel) {
            const payload: IDuplicateCatalogDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid,
                name: `Copy of ${catalogModel.name}`,
                active: false,
            };

            this.props.socket.emit(EndpointsEnum.CatalogsDuplicateCatalog, payload);

            this.setState({
                duplicateActive: true,
            });
        }
    };

    onDuplicateCatalog = (data: IOnDuplicateCatalogDTO) => {
        const notification: INotification = {
            message: "successfully_duplicated_catalog",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.getCatalogs();

        this.setState({
            duplicateActive: false,
        });
    };

    showReconcileVendorLocationsModal = () => {
        const modalComponent = (
            <CatalogReconcileVendorLocations
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    auditInventory = async () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        this.setState({ actionActive: true });

        try {
            const response = await InventoryService.auditInventory(catalogGuid, this.props.userModel, this.props.supplierModel);

            console.log("Inventory Audit Results:", response);
        } catch (error) {
            console.error("Error auditing inventory:", error);
        } finally {
            this.setState({ actionActive: false });
        }
    };

    auditAndFixInventory = async () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        this.setState({ actionActive: true });

        try {
            const response = await InventoryService.auditAndFixInventory(catalogGuid, this.props.userModel, this.props.supplierModel);

            console.log("Inventory Audit and Fix Results:", response);
        } catch (error) {
            console.error("Error auditing and fixing inventory:", error);
        } finally {
            this.setState({ actionActive: false });
        }
    };
    closeContextModal = () => {
        this.props.uiContext.setModalComponent(null);
        this.props.uiContext.showModal(false);
    };
    showResetInventoryModal = () => {
        const catalogGuid = this.getCheckedCatalogGuid();
        const catalogModel = this.state.catalogs.find((catalog) => catalog.guid === catalogGuid);

        if (!catalogModel) return;

        const modalComponent = (
            <InventoryResetModal
                closeModalFn={this.closeContextModal}
                notifyFn={this.props.notifyFn}
                catalogGuid={catalogGuid}
                catalogName={catalogModel.name}
                onSubmit={this.resetInventory}
            />
        );

        this.props.uiContext.setModalComponent(modalComponent);
        this.props.uiContext.showModal(true);
    };

    resetInventory = async (body: IInventoryResetDTO) => {
        this.closeContextModal();

        this.setState({
            actionActive: true,
        });

        try {
            const response = await InventoryService.resetInventory(body, this.props.userModel, this.props.supplierModel);

            console.log("Inventory Reset Response:", response);

            if (response.success && response) {
                this.onInventoryReset(response);
            } else {
                throw new Error("Inventory reset failed");
            }
        } catch (error) {
            console.error("Error resetting inventory:", error);

            const notification: INotification = {
                message: "error_resetting_inventory",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            };

            this.props.notifyFn(null, notification);
        } finally {
            this.setState({ actionActive: false });
        }
    };

    onInventoryReset = (data: IOnInventoryResetDTO) => {
        const isDryRun = data.dryRun;

        const notification: INotification = {
            message: isDryRun ? "inventory_reset_preview_complete" : "inventory_reset_complete",
            level: data.errors.length > 0 ? NotificationLevelEnum.warning : NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        console.log("Inventory Reset Results:", data.summary);

        if (data.errors.length > 0) {
            console.warn("Inventory Reset Errors:", data.errors);
        }

        if (!isDryRun) {
            this.getCatalogs();
        }
    };
    recalculateReservedQtyOnHand = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IRecalculateReservedQtyOnHandDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsRecalculateReservedQtyOnHand, payload);

        this.setState({
            actionActive: true,
        });
    };

    onRecalculateReservedQtyOnHand = (data: IOnRecalculateReservedQtyOnHandDTO) => {
        console.log("Recalculate Reserved Qty On Hand: ", data);

        const notification: INotification = {
            message: "successfully_recalculated_reserved_qty_on_hand",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            actionActive: false,
        });
    };

    deduplicate = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: ICatalogDeduplicateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogDeduplicate, payload);

        this.setState({
            actionActive: true,
        });
    };

    onDeduplicate = (data: IOnCatalogDeduplicateDTO) => {
        this.setState({
            actionActive: true,
        });
    };

    reconcilePriceGroups = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IReconcilePriceGroupsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogReconcilePriceGroups, payload);

        this.setState({
            actionActive: true,
        });
    };

    onReconcilePriceGroups = (data: IOnReconcilePriceGroupsDTO) => {
        this.setState({
            showSyncStatus: true,
            processedItemsDetails: data,
            actionActive: false,
        });
    };

    getImagesCSV = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: ICatalogGetImagesCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogGetImagesCSV, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "images",
        });
    };

    onGetImagesCSV = (data: IOnGetCatalogImagesCsvDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    getItemOptionsBulkAssignCSV = async () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "item_options_bulk_assign",
        });

        try {
            const url = buildRestUrl({
                endpoint: RestEndpointsEnum.CatalogGetItemOptionsAssignmentTemplate,
                params: { catalogGuid },
            });

            const headers = buildAuthHeadersForFetch({
                userModel: this.props.userModel,
                supplierModel: this.props.supplierModel,
            });

            const response = await fetch(url, {
                method: "GET",
                headers,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data: IOnGetItemOptionAssignmentTemplateDTO = await response.json();

            this.downloadCSVData(data.csvData, data.filename);
        } catch (error) {
            console.error("Error fetching item options bulk apply CSV:", error);
        } finally {
            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    getWineExcelExport = async () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "wine_excel_export",
        });

        try {
            const url = buildRestUrl({
                endpoint: RestEndpointsEnum.WineExcelExport,
                params: { catalogGuid },
            });

            const headers = buildAuthHeadersForFetch({
                userModel: this.props.userModel,
                supplierModel: this.props.supplierModel,
                includeContentType: false,
            });

            const response = await fetch(url, {
                method: "GET",
                headers,
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            // Extract filename from Content-Disposition header
            const contentDisposition = response.headers.get("Content-Disposition");
            let filename = "wine-export";

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1].replace(/['"]/g, "");
                }
            }

            // Determine file extension based on Content-Type if not in filename
            const contentType = response.headers.get("Content-Type") || "";
            if (!filename.includes(".")) {
                if (contentType.includes("application/zip")) {
                    filename += ".zip";
                } else {
                    filename += ".xlsx";
                }
            }

            // Trigger download
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            URL.revokeObjectURL(link.href);

            const notification: INotification = {
                message: "by_price_group_price_export_download_complete",
                level: NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
            };
            this.props.notifyFn(null, notification);
        } catch (error) {
            console.error("Error downloading wine Excel export:", error);

            const notification: INotification = {
                message: error instanceof Error ? error.message : "export_download_failed",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
                skipMessageTranslate: error instanceof Error,
            };
            this.props.notifyFn(null, notification);
        } finally {
            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    getCatalogCSVAttributes = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IGetCatalogCSVAttributesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogCSVAttributes, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "attributes",
        });
    };

    getCatalogCSVCategories = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IGetCatalogCSVCategoryTemplate = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogCSVCategoryTemplate, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "categories",
        });
    };

    onGetCatalogCSVCategories = (data: IOnGetCatalogCSVCategoryTemplateDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    onGetCatalogCSVPriceGroups = (data: IOnGetCatalogCSVPriceGroupsDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    getMaterialsTemplate = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IGetMaterialsTemplateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.MaterialsGetCatalogItemTemplate, payload);
    };

    onGetMaterialsTemplate = (data: IOnGetMaterialsTemplateDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);
        }
    };

    getCatalogItemCategories = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IGetCatalogCSVItemCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogCSVItemCategories, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "item_categories",
        });
    };

    getCatalogItemTemplate = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const modalComponent = (
            <ItemTemplateDownloadModal
                closeModalFn={this.closeModal}
                onDownload={(filters) => this.downloadItemTemplate(catalogGuid, filters)}
                catalogGuid={catalogGuid}
                socket={this.props.socket}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.setState({ modalComponent, modalIsOpen: true });
    };

    downloadItemTemplate = (catalogGuid: string, filters: ItemTemplateDownloadFilters) => {
        const payload: IGetCatalogCSVItemTemplateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
            excludeCategoryGuids: filters.excludeCategoryGuids.length > 0 ? filters.excludeCategoryGuids : undefined,
            activeFilter: filters.activeFilter,
            itemMatchPattern: filters.itemMatchPattern,
            useRegex: filters.useRegex,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogCSVItemTemplate, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "item_template",
            modalIsOpen: false,
            modalComponent: null,
        });
    };

    getCatalogCSVKitBuilderTemplate = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IGetCatalogCSVKitBuilderTemplateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogCSVKitBuilderTemplate, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "kit_builder_template",
        });
    };

    getCatalogCSVPriceUpdate = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IGetCatalogCSVPriceUpdateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogCSVPriceUpdate, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "price_list",
        });
    };

    getCatalogCSVPriceBandsBulkApply = () => {
        const catalogGuid = this.getCheckedCatalogGuid();
        const payload: IGetPriceBandsBulkApplyCsvTemplateDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetPriceBandsBulkApplyCsvTemplate, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "price_bands_bulk_apply",
        });
    };

    getCatalogCSVPriceBands = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IGetCatalogCSVPriceBandsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogCSVPriceBands, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "price_bands",
        });
    };

    getCatalogCSVPriceGroup = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IGetCatalogCSVPriceGroupsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogCSVPriceGroups, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "price_groups",
        });
    };

    getCatalogCSVInventory = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IGetCatalogCSVInventoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogCSVInventory, payload);

        this.setState({
            downloadCsvActive: true,
            downloadCsvAction: "inventory",
        });
    };

    qboSyncCatalogItemsStart = (data: IQBOSyncCatalogItemsStartDTO) => {
        this.setState({
            currentQboPullTotal: data.totalItems,
        });
    };

    qboSyncCatalogItemsUpdate = (data: IQBOSyncCatalogItemsUpdateDTO) => {
        this.setState({
            currentQboPullStart: data.startPosition,
        });
    };

    qboSyncCatalogItemsEnd = (data: IQBOSyncCatalogItemsEndDTO) => {
        this.setState({
            currentQboPullStart: this.state.currentQboPullTotal,
        });
    };

    isXeroActive = (): boolean => {
        return this.state.xeroGetItemsActive;
    };

    isQboSyncActive = (name: string): boolean => {
        if (name === "pull_inventory") {
            return this.state.activeSyncCatalogItems;
        }

        if (name === "pull_catalog_items") {
            return this.state.activePullQboItems;
        }

        return false;
    };

    isNotWooCommerceCatalog = (): boolean => {
        const disableCheckedActions = this.hasOnlyOneChecked();

        const selectedCatalogGuid = this.getCheckedCatalogGuid();

        let isDisabled = true;

        if (disableCheckedActions) {
            return isDisabled;
        }

        if (this.props.supplierModel.Supplier_Integration.woocommerce_options?.default_catalog_id) {
            const catalogModel = this.state.catalogs.find((catalog) => {
                return catalog.id === Number(this.props.supplierModel.Supplier_Integration.woocommerce_options?.default_catalog_id);
            });

            if (catalogModel) {
                isDisabled = !(catalogModel.guid === selectedCatalogGuid);

                return isDisabled;
            } else {
                return isDisabled;
            }
        } else {
            return isDisabled;
        }
    };

    hasOnlyOneChecked = (): boolean => {
        const keys = Object.keys(this.state.checkedRows);

        let hasOnlyOneChecked = true;

        let count = 0;

        for (const key of keys) {
            if (this.state.checkedRows[key]) {
                count++;
            }
        }

        if (count > 1) {
            hasOnlyOneChecked = false;
        }

        if (!count) {
            hasOnlyOneChecked = false;
        }

        return !hasOnlyOneChecked;
    };

    confirmDelete = (catalog: ICatalog, index: number) => {
        const selectedRowElem = document.getElementById(`row-${index}`);

        this.setState({
            selectedCatalog: catalog,
            selectedRowElem,
            selectedRowElemId: `row-${index}`,
        });
    };

    actionsCol = (data: ICatalog, index: number) => {
        if (this.props.isReadOnly) {
            return null;
        }

        return (
            <div className={"d-flex align-items-center"}>
                {this.props.userModel?.isSupplierUser ? (
                    <OwCheckbox
                        name={data.guid}
                        truthyVal={true}
                        falsyVal={false}
                        fn={this.setChecked}
                        checked={this.state.checkedRows[data.guid]}
                        className={"ms-4 me-4"}
                    />
                ) : null}
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={() => {
                        this.confirmDelete(data, index);
                    }}
                    onEditClickFn={() => {
                        this.openCatalogSidebar(data);
                    }}
                />
            </div>
        );
    };

    setChecked = (e: any) => {
        console.log("setChecked", e);
        const checkedGuid = e.target.name;

        const checkedRows = this.state.checkedRows;

        // only allow 1 row to be checked
        for (const key of Object.keys(checkedRows)) {
            if (checkedRows[key]) {
                checkedRows[key] = false;
            }
        }

        checkedRows[checkedGuid] = e.target.value;

        this.setState({
            checkedRows,
        });
    };

    getActiveIcon = (isActive: boolean) => {
        if (isActive) {
            return <i className={"text-success fad fa-check-circle"} />;
        } else {
            return <i className={"text-danger fad fa-times-circle"} />;
        }
    };

    renderCurrency = (row: ICatalog) => {
        const currency = row.Currency?.name;

        if (currency) {
            return currency;
        } else {
            return "";
        }
    };

    getHasPDF = (row: ICatalog) => {
        if (row.PDF) {
            return <i className={"text-success fad fa-check-circle"} />;
        } else {
            return "--";
        }
    };

    downloadCSVData = (csvData: any, filename: string) => {
        const blob = new Blob([csvData], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = filename;
        link.click();
    };

    onGetCatalogCSVInventory = (data: IOnGetCatalogCSVInventoryDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    onGetCatalogCSVPriceGroup = (data: IOnGetCatalogCSVPriceUpdateDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    onGetCatalogCSVItemCategories = (data: IOnGetCatalogCSVItemCategoriesDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    onGetCatalogCSVAttributes = (data: IOnGetCatalogCSVAttributesDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    onGetPriceBandsBulkApplyCsvTemplate = (data: IOnGetPriceBandsBulkApplyCsvTemplateDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    onGetCatalogCSVKitBuilderTemplate = (data: IOnGetCatalogCSVKitBuilderTemplateDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    onGetCatalogCSVItemTemplate = (data: IOnGetCatalogCSVItemTemplateDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    onGetCatalogCSVPriceBands = (data: IOnGetCatalogCSVPriceBandsDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                downloadCsvActive: false,
                downloadCsvAction: "",
            });
        }
    };

    qboOnPullAndDownloadCatalogItems = (data: IQBOOnPullAndDownloadCatalogItemsDTO) => {
        if (data) {
            this.downloadCSVData(data.csvData, data.filename);

            this.setState({
                activePullQboItems: false,
            });
        }
    };

    onGetCatalogCSVItemInventoryUpdate = (data: IOnPerformCatalogCSVItemTemplateUpdateDTO) => {};

    getCatalogs = () => {
        if (!this.state.isFetchingData) {
            const payload: IGetCatalogsDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
            };

            this.props.socket.emit("getCatalogs", payload);

            this.setState({
                isFetchingData: true,
            });
        }
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        const catalogs = _.each(data.catalogs, (catalog: ICatalog) => {
            return catalog;
        });

        this.setState(
            {
                catalogs: catalogs as ICatalogUI[],
                isFetchingData: false,
                isInitialData: false,
            },
            () => {
                this.props.setActivityIndicator(false);
            }
        );
    };

    onCreateCatalog = (data: any) => {};

    getCheckedCatalogGuid = (): string => {
        const checkedItems = Object.keys(this.state.checkedRows);

        let catalogGuid = "";

        for (const checkedItem of checkedItems) {
            if (this.state.checkedRows[checkedItem]) {
                catalogGuid = checkedItem;
            }
        }

        return catalogGuid;
    };

    showNYSLAExportModal = () => {
        const catalogGuid = this.getCheckedCatalogGuid();
        const catalog = this.state.catalogs.find((c) => c.guid === catalogGuid);

        if (!catalog) {
            return;
        }

        const modalComponent = (
            <NYSLAExportModal
                closeModalFn={this.closeModal}
                catalogGuid={catalogGuid}
                priceGroups={catalog.Price_Groups || []}
                notifyFn={this.props.notifyFn}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    showNYSLASetupAttributesModal = () => {
        const catalogGuid = this.getCheckedCatalogGuid();
        const catalog = this.state.catalogs.find((c) => c.guid === catalogGuid);

        if (!catalog) {
            return;
        }

        const modalComponent = (
            <NYSLASetupAttributesModal
                closeModalFn={this.closeModal}
                catalogGuid={catalogGuid}
                catalogName={catalog.name}
                notifyFn={this.props.notifyFn}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    getCheckedCatalogId = (): number => {
        const checkedItems = Object.keys(this.state.checkedRows);

        let catalogId = 0;

        for (const checkedItem of checkedItems) {
            if (this.state.checkedRows[checkedItem]) {
                for (const catalog of this.state.catalogs) {
                    if (catalog.guid === checkedItem) {
                        catalogId = catalog.id;
                    }
                }
            }
        }

        return catalogId;
    };

    qboSyncInventory = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        // this.state.catalogs[index].syncItems = true;

        console.log(this.state.catalogs);

        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit("qboSyncInventory", payload);

        this.setState({
            activeSyncCatalogItems: true,
        });

        // this.forceUpdate();
    };

    onSyncInventory = (data: any) => {
        console.log("onQboSyncInventory");
        const catalogs = this.state.catalogs;

        _.each(catalogs, (catalog) => {
            catalog.syncItems = false;
        });

        console.log(this.state.catalogs);

        const notification = {
            message: "SUCCESSFULLY_SYNCED_CATALOG_ITEMS",
            level: "success",
            position: "br",
        };

        this.props.notifyFn(null, notification);

        this.setState({
            activeSyncCatalogItems: false,
        });
    };

    showQboPushCatalogItemsModal = () => {
        const modalComponent = <QboPushCatalogItemsModal closeModalFn={this.closeModal} startPushFn={this.pushQboCatalogItems} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    pushQboCatalogItems = (payload: IQBOPushCatalogItemsDTO) => {
        const catalogGuid = this.getCheckedCatalogGuid();

        payload.catalogGuid = catalogGuid;

        this.props.socket.emit(EndpointsEnum.QBOPushCatalogItems, payload);

        this.setState({
            activePushQboItems: true,
            modalIsOpen: false,
            modalComponent: null,
        });
    };

    showConnectQboCatalogItemsModal = () => {
        const modalComponent = <ConnectQboCatalogItemsModal closeModal={this.closeModal} startSync={this.connectQboCatalogItems} />;

        this.setState({
            modalIsOpen: true,
            modalComponent,
        });
    };

    connectQboCatalogItems = (options: { onlyUnconnectedItems: boolean }) => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IQBOConnectCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        if (options.onlyUnconnectedItems) {
            payload.onlyUnconnectedItems = true;
        }

        this.props.socket.emit(EndpointsEnum.QBOConnectCatalogItems, payload);

        this.setState({
            activeConnectQboItems: true,
        });
    };

    qboPullAndDownloadProductsFn = () => {
        const payload: IQBOPullAndDownloadCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOPullAndDownloadCatalogItems, payload);

        this.setState({
            activePullQboItems: true,
        });
    };

    qboDownloadCategories = async () => {
        this.setState({ activeDownloadQboCategories: true });

        try {
            const url = buildRestUrl({
                endpoint: RestEndpointsEnum.QBODownloadCategories,
            });

            const headers = buildAuthHeadersForFetch({
                userModel: this.props.userModel,
                supplierModel: this.props.supplierModel,
                includeContentType: false,
            });

            const response = await fetch(url, {
                method: "GET",
                headers,
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }

            // Get filename from Content-Disposition header or use default
            const contentDisposition = response.headers.get("Content-Disposition");
            let filename = "qbo-categories.csv";
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match) {
                    filename = match[1];
                }
            }

            const csvData = await response.text();
            this.downloadCSVData(csvData, filename);
        } catch (error) {
            console.error("Error downloading QBO categories:", error);
        } finally {
            this.setState({ activeDownloadQboCategories: false });
        }
    };

    qboDownloadReconcileFile = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IQBOReconcileCatalogAndQboItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.QBOReconcileCatalog, payload);

        this.setState({
            activePullQboItems: true,
        });
    };
    onQboDownloadReconcileFile = (data: IQBOOnReconcileCatalogAndQboItemsDTO) => {
        UIService.downloadDataFile(
            data.workbook,
            "Orderwerks QBO Reconcile File.xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );

        this.setState({
            activePullQboItems: false,
        });
    };

    qboDownloadReconciliationInventoryExcel = () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IQuickBooksOnlineInventoryReconciliationDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
            includeReservedQoH: true,
        };

        this.props.socket.emit(EndpointsEnum.QBODownloadReconciliationExcel, payload);

        this.setState({
            activePullQboItems: true,
        });
    };

    onQboDownloadReconcilationExcel = (data: IQuickBooksOnlineOnInventoryReconciliationDTO) => {
        UIService.downloadDataFile(
            data.workbook,
            `Orderwerks QBO Inventory Reconcile File - ${moment().format("YYYY-MM-DD")}.xlsx`,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );

        this.setState({
            activePullQboItems: false,
        });
    };

    showQboPullCatalogItemsModel = () => {
        const modalComponent = <QBOPullCatalogItemsModal closeModalFn={this.closeModal} startPullFn={this.pullQboCatalogItems} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    pullQboCatalogItems = (lastPullTime?: string, pullCategories?: boolean, rePullImages?: boolean) => {
        const catalogGuid = this.getCheckedCatalogGuid();

        const payload: IQBOSyncCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid,
            lastPullTime,
            pullCategories,
            rePullImages,
        };

        this.props.socket.emit(EndpointsEnum.QBOSyncCatalogItems, payload);

        this.setState({
            activePullQboItems: true,
            modalComponent: null,
            modalIsOpen: false,
        });
    };

    showQboPullCategoriesModal = () => {
        const modalComponent = <QBOPullCategoriesModal closeModalFn={this.closeModal} startPullFn={this.pullQboCategories} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    pullQboCategories = async () => {
        const catalogGuid = this.getCheckedCatalogGuid();

        // Show loading state in modal (keep modal open)
        this.setState({
            activePullQboCategories: true,
            modalComponent: <QBOPullCategoriesModal closeModalFn={this.closeModal} startPullFn={this.pullQboCategories} isLoading={true} />,
        });

        try {
            const url = buildRestUrl({
                endpoint: RestEndpointsEnum.QBOPullCategories,
                params: {},
            });

            const headers = buildAuthHeadersForFetch({
                userModel: this.props.userModel,
                supplierModel: this.props.supplierModel,
            });

            const response = await fetch(url, {
                method: "POST",
                headers,
                body: JSON.stringify({ catalogGuid }),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }

            const data: IQBOOnPullCategoriesDTO = await response.json();

            // Show results in modal
            this.setState({
                activePullQboCategories: false,
                modalComponent: (
                    <QBOPullCategoriesModal closeModalFn={this.closeModal} startPullFn={this.pullQboCategories} results={data} />
                ),
            });
        } catch (error) {
            // Show error in modal
            this.setState({
                activePullQboCategories: false,
                modalComponent: (
                    <QBOPullCategoriesModal
                        closeModalFn={this.closeModal}
                        startPullFn={this.pullQboCategories}
                        error={error instanceof Error ? error.message : "Failed to pull categories"}
                    />
                ),
            });
        }
    };

    onPushQboCatalogItems = (data: IQBOOnPushCatalogItemsDTO) => {
        const notification: INotification = {
            message: "successfully_pushed_catalog_items",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        console.log("Errored Rows: ", data.erroredRows, data.errorReasons);
        this.setState({
            activePushQboItems: false,
            qboPushErroredRowsDetail: data.errorReasons,
            qboPushErroredRows: data.erroredRows,
        });
    };

    onConnectQboCatalogItems = (data: IQBOOnConnectCatalogItemsDTO) => {
        const notification: INotification = {
            message: "successfully_connected_catalog_items",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            activeConnectQboItems: false,
        });
    };

    qboOnSyncCatalogItems = (data: IQBOOnSyncCatalogItemsDTO) => {
        this.setState({
            activePullQboItems: false,
            showPullQboDismiss: true,
        });
    };

    parseLastInventoryUpdated = (date: string): string => {
        if (date) {
            return UserService.parseLastUpdated(date, true);
        } else {
            return "--";
        }
    };

    parseLastUpdated = (date: string): string => {
        if (date) {
            return UserService.parseLastUpdated(date);
        } else {
            return "--";
        }
    };

    toggleSidebar = (refreshData?: boolean) => {
        if (refreshData) {
            this.getCatalogs();
        }

        this.props.toggleSidebar();
    };

    getSidebarComponent = (catalog?: ICatalog) => {
        return <CatalogSidebar catalogModel={catalog} cancel={this.toggleSidebar} />;
    };

    openCatalogSidebar = (catalog?: ICatalog) => {
        // console.log('Toggle Sidebar', shipment, index);
        const sidebarComp = this.getSidebarComponent(catalog);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar();
    };

    dismissShopifySync = () => {
        this.setState({
            showShopifySyncDetails: false,
            currentShopifyTotalProducts: 0,
            currentShopifyProcessed: 0,
        });
    };

    dismissQboPullCard = () => {
        this.setState({
            showPullQboDismiss: false,
            currentQboPullStart: 0,
            currentQboPullTotal: 0,
        });
    };

    afterOpenModal = () => {};

    closeModal = () => {
        this.setState({
            modalComponent: null,
            modalIsOpen: false,
        });
    };

    getDetailRow = (row: ICatalog, index: number) => {
        return (
            <CatalogDetailView
                catalogModel={row}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                setActivityIndicator={this.props.setActivityIndicator}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
            />
        );
    };

    cancelDelete = () => {
        this.setState({
            selectedRowElem: null,
            selectedCatalog: undefined,
            selectedRowElemId: null,
        });
    };

    commitDelete = () => {
        if (this.state.selectedCatalog) {
            const payload: IDeleteCatalogDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: this.state.selectedCatalog.guid,
            };

            this.props.socket.emit(EndpointsEnum.CatalogsDeleteCatalog, payload);

            this.setState({
                selectedRowElem: null,
                selectedCatalog: undefined,
                selectedRowElemId: null,
            });
        }
    };

    onDeleteCatalog = (data: IOnDeleteCatalogDTO) => {
        const notification: INotification = {
            message: "successfully_deleted_catalog",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.getCatalogs();
    };

    closeSyncStatus = () => {
        this.setState({
            showSyncStatus: false,
            processedItemsDetails: null,
        });
    };

    render() {
        let cardStyle = "text-white bg-dark";

        if (UIService.isMainViewLight()) {
            cardStyle = "";
        }

        return (
            <div className="Catalogs position-relative">
                {/*<Breadcrumbs navItems={this.state.navItems} />*/}
                <ReactTooltip
                    getContent={(dataTip) => {
                        return dataTip;
                    }}
                    effect="solid"
                    place="right"
                />

                <div className="row mt-2">
                    <div className="col-12 d-flex align-items-center justify-items-center">
                        <OwTitle title="catalogs" leftIconName="fad fa-books me-1" />
                        {/*<h2 className="mt-3 d-inline-flex"><i className="far fa-books me-1"></i>Catalogs</h2>*/}
                        {this.props.isReadOnly ? null : (
                            <OwButton
                                id={"create"}
                                className={"ms-2 btn-warning"}
                                title={"create"}
                                fn={() => {
                                    this.openCatalogSidebar();
                                }}
                                leftIconClass={"fas fa-plus"}
                            />
                        )}
                    </div>
                </div>

                <OwProcessedItemsDetails details={this.state.processedItemsDetails} dismissProcessedDetails={this.closeSyncStatus} />

                {this.state.activePushQboItems || this.state.showPushQboDismiss || this.state.activeConnectQboItems ? (
                    <div className={"card " + (UIService.isMainViewLight() ? "" : "text-white bg-dark")}>
                        <div className={"card-body"}>
                            {this.state.showPushQboDismiss ? (
                                <div className={"pointer text-primary"} onClick={this.dismissQboPullCard}>
                                    [ <i className={"fa fa-times"} /> ] <OwLabel className={"pointer"} title={"dismiss"} />
                                </div>
                            ) : null}
                            <div>
                                <OwLabel
                                    title={this.state.activeConnectQboItems ? "connect_catalog_items" : "push_catalog_items"}
                                    isBold={true}
                                />
                            </div>
                            <div>
                                <OwLabel title={"progress"} />: {this.state.currentQboPullStart} / {this.state.currentQboPullTotal}
                            </div>
                            {this.state.qboPushErroredRows ? (
                                <div>
                                    <div>
                                        <OwLabel title={"errors"} /> {this.state.qboPushErroredRows}
                                    </div>
                                    <div>
                                        <pre>{this.state.qboPushErroredRowsDetail}</pre>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                ) : null}

                {this.state.activePullQboItems || this.state.showPullQboDismiss ? (
                    <div className={"card " + cardStyle}>
                        <div className={"card-body"}>
                            {this.state.showPullQboDismiss ? (
                                <div className={"pointer text-primary"} onClick={this.dismissQboPullCard}>
                                    [ <i className={"fa fa-times"} /> ] <OwLabel className={"pointer"} title={"dismiss"} />
                                </div>
                            ) : null}
                            <div>
                                <OwLabel title={"pull_catalog_items"} isBold={true} />
                            </div>
                            <div>
                                <OwLabel title={"progress"} />: {this.state.currentQboPullStart} / {this.state.currentQboPullTotal}
                            </div>
                        </div>
                    </div>
                ) : null}

                {this.state.activeShopifySync || this.state.showShopifySyncDetails ? (
                    <div className={"card " + cardStyle}>
                        <div className={"card-body"}>
                            {this.state.showShopifySyncDetails ? (
                                <div className={"pointer text-primary"} onClick={this.dismissShopifySync}>
                                    [ <i className={"fa fa-times"} /> ] <OwLabel className={"pointer"} title={"dismiss"} />
                                </div>
                            ) : null}
                            <div>
                                <OwLabel title={"pull_catalog_items"} isBold={true} />
                            </div>
                            <div>
                                <OwLabel title={"progress"} />: {this.state.currentShopifyProcessed} /{" "}
                                {this.state.currentShopifyTotalProducts}
                            </div>
                        </div>
                    </div>
                ) : null}

                {this.state.showShopifySyncDetails ? (
                    <div className={"card " + cardStyle}>
                        <div className={"card-body"}>
                            <div>
                                <div className={"pointer text-primary"} onClick={this.dismissShopifySyncDetails}>
                                    [ <i className={"fa fa-times"} /> ] <OwLabel className={"pointer"} title={"dismiss"} />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <OwLabel title={"total_records"} postText={":"} className={"me-1"} />
                                    {this.state.shopifySyncDetails.totalRecords}
                                </div>
                                <div>
                                    <OwLabel title={"records_created"} postText={":"} className={"me-1"} />
                                    {this.state.shopifySyncDetails.recordsCreated}
                                </div>
                                <div>
                                    <OwLabel title={"records_updated"} postText={":"} className={"me-1"} />
                                    {this.state.shopifySyncDetails.recordsUpdated}
                                </div>
                                <div>
                                    <OwLabel title={"records_errored"} postText={":"} className={"me-1"} />
                                    {this.state.shopifySyncDetails.recordsErrored}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                <div>
                    {this.props.isReadOnly ? null : (
                        <OwActionBar
                            toggleSmallTable={() => {}}
                            colToggledFn={() => {}}
                            columns={{}}
                            actions={this.state.actions}
                            hideTableTypeSelect={true}
                            hideColumnToggle={true}
                            disabled={false}
                        />
                    )}
                </div>

                <div className={"table-responsive position-relative"}>
                    <ConfirmDeleteOverlayFn
                        targetElem={this.state.selectedRowElemId}
                        handleConfirm={this.commitDelete}
                        handleCancel={this.cancelDelete}
                        nestedParentElem={"catalog-table"}
                        skipMainView={true}
                    />

                    <OwTable
                        id={"catalog-table"}
                        columns={this.state.tableCols}
                        dataSet={this.state.catalogs}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isFetchingData}
                        initialData={this.state.isInitialData}
                        tableConfig={{ tableStriped: true, hasDetailView: false }}
                    />
                </div>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalContentClass"}
                        overlayClassName={"modalOverlayClass"}
                        style={this.state.modalStyle}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}

export default Catalogs;
